export default __webpack_public_path__ + "static/media/barrels.c9a781bd.png";